export default __webpack_public_path__ + "static/media/B2B - Portfolio.94adc7a7.png";